import React, { useState } from 'react'
import './header.styles.scss'
import Button from '@mui/material/Button';
import { ReactComponent as Logo } from '../../../Assets/logo.svg'
import { ReactComponent as Burger } from '../../../Assets/burger.svg'
import { ReactComponent as Cross } from '../../../Assets/cross.svg'
import Menu from '@mui/material/Menu';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Language from '../../Language/Language';

const Header = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className='mainHeader'>
            <div className='logo'>
                <Logo onClick={() => navigate('home')} style={{width: "80%"}}/>
            </div>
            <div className='buttonContainer'>
                <Button
                aria-label={t("aboutUs")}
                    variant="text"
                    onClick={() => navigate('about')}
                    className={window.location.pathname === "/about" && "active"}
                >
                    {t("aboutUs")}
                </Button>
                <Button
                aria-label={t("smartbip")}
                    variant="text"
                    onClick={() => navigate('smartbip')}
                    className={window.location.pathname.includes('smartbip') && "active"}
                >
                    {t("smartbip")}
                </Button>
                <Button
                aria-label={t("faq")}
                    variant="text"
                    onClick={() => navigate('faq')}
                    className={window.location.pathname === "/faq" && "active"}
                >
                    {t("faq")}
                </Button>
                <Language />
                <Button
                aria-label={t("contactUs")}
                    variant="contained"
                    style={{ backgroundColor: '#416D03' }}
                    onClick={() => navigate('contact')}
                >
                    {t("contactUs")}
                </Button>
            </div>
            <div className='burgerMenu'>
                <Button
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                >
                    {open ?
                        <Cross />
                        :
                        <Burger />
                    }
                </Button>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <Button aria-label={t("aboutUs")} variant="text" onClick={() => { navigate('about'); setAnchorEl(null); }}>{t("aboutUs")}</Button>
                    <Button aria-label={t("smartbip")} variant="text" onClick={() => { navigate('smartbip'); setAnchorEl(null); }}>{t("smartbip")}</Button>
                    <Button aria-label={t("faq")} variant="text" style={{ textAlign: 'left' }} onClick={() => { navigate('faq'); setAnchorEl(null); }}>{t("faq")}</Button>
                    <Language />
                    <Button aria-label={t("contactUs")} variant="contained" style={{ backgroundColor: '#416D03' }} onClick={() => { navigate('contact'); setAnchorEl(null); }}>{t("contactUs")}</Button>
                </Menu>
            </div>
        </div>
    )
}

export default Header